module.exports = __webpack_public_path__ + "img/gjd-icon.9d05abd2.png";